module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-down-button",
    style: (_vm.canvasStyle)
  }, [_c('div', {
    staticClass: "pull-down-button__canvas",
    style: ({
      'width': _vm.width + 'px'
    })
  }, [(_vm.show) ? _c('div', [_c('div', {
    staticClass: "pull-down-button__canvas-shown"
  }, [_c('scroll-panel', {
    attrs: {
      "height": _vm.scrollHeight
    }
  }, [_vm._t("default")], 2)], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pull-down-button__button-area"
  }, [_c('div', {
    ref: "button",
    staticClass: "pull-down-button__button",
    style: (_vm.buttonPosition),
    on: {
      "click": _vm.toggleHiddenSection
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), (_vm.show) ? _c('icon', {
    staticClass: "pull-down-button__arrowPosition",
    attrs: {
      "name": "caret-up",
      "scale": "1.2"
    }
  }) : _c('icon', {
    staticClass: "pull-down-button__arrowPosition",
    attrs: {
      "name": "caret-down",
      "scale": "1.2"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19d67441"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/pullDownButton/PullDownButton.vue
// module id = 2409
// module chunks = 0